import { convertUtcToAccountLocal, getAccountTimezone } from "./timezoneUtils";
export const calculateInteractionTimings = (interaction) => {
    const NEGATIVE_TOLERANCE_SECONDS = 5;
    let readInSeconds = null;
    let callbackInSeconds = null;
    if (interaction.SecureMessageReadUtc && interaction.SecureMessageSentUtc) {
        try {
            const readTime = new Date(interaction.SecureMessageReadUtc).getTime();
            const sentTime = new Date(interaction.SecureMessageSentUtc).getTime();
            if (!isNaN(readTime) && !isNaN(sentTime)) {
                const duration = (readTime - sentTime) / 1000;
                if (duration >= 0) {
                    readInSeconds = Math.round(duration);
                }
                else if (duration >= -NEGATIVE_TOLERANCE_SECONDS) {
                    readInSeconds = 0;
                }
            }
        }
        catch (error) {
            console.warn("Error calculating ReadInSeconds:", error);
        }
    }
    if (interaction.CallbackFromMessageIdUtc && interaction.SecureMessageSentUtc) {
        try {
            const callbackTime = new Date(interaction.CallbackFromMessageIdUtc).getTime();
            const sentTime = new Date(interaction.SecureMessageSentUtc).getTime();
            if (!isNaN(callbackTime) && !isNaN(sentTime)) {
                const duration = (callbackTime - sentTime) / 1000;
                if (duration >= 0) {
                    callbackInSeconds = Math.round(duration);
                }
                else if (duration >= -NEGATIVE_TOLERANCE_SECONDS) {
                    callbackInSeconds = 0;
                }
            }
        }
        catch (error) {
            console.warn("Error calculating CallbackInSeconds:", error);
        }
    }
    return {
        ReadInSeconds: readInSeconds,
        CallbackInSeconds: callbackInSeconds,
    };
};
export const addLocalDateToInteraction = (interaction, accountTimezone) => {
    const timezone = accountTimezone || getAccountTimezone(interaction.ToFilterObjectAccountId) || undefined;
    const localStartDate = convertUtcToAccountLocal(interaction.InteractionStartDateUtc, timezone);
    const timings = calculateInteractionTimings(interaction);
    const result = {
        ...interaction,
        InteractionStartDate: localStartDate,
        ReadInSeconds: timings.ReadInSeconds,
        CallbackInSeconds: timings.CallbackInSeconds,
    };
    if (interaction.SecureMessageSentUtc) {
        result.SecureMessageSent = convertUtcToAccountLocal(interaction.SecureMessageSentUtc, timezone);
    }
    if (interaction.PushNotificationSentUtc) {
        result.PushNotificationSent = convertUtcToAccountLocal(interaction.PushNotificationSentUtc, timezone);
    }
    if (interaction.SecureMessageReadUtc) {
        result.SecureMessageRead = convertUtcToAccountLocal(interaction.SecureMessageReadUtc, timezone);
    }
    if (interaction.CallbackFromMessageIdUtc) {
        result.CallbackFromMessageId = convertUtcToAccountLocal(interaction.CallbackFromMessageIdUtc, timezone);
    }
    return result;
};
export const addLocalDatesToInteractions = (interactions, accountTimezones) => {
    return interactions.map((interaction) => {
        const timezone = (accountTimezones === null || accountTimezones === void 0 ? void 0 : accountTimezones[interaction.ToFilterObjectAccountId]) ||
            getAccountTimezone(interaction.ToFilterObjectAccountId);
        return addLocalDateToInteraction(interaction, timezone);
    });
};
export const addLocalDatesToInteractionsByAccount = (interactionsByAccount, accountTimezones) => {
    const result = {};
    for (const [entityId, interactions] of Object.entries(interactionsByAccount)) {
        result[entityId] = addLocalDatesToInteractions(interactions, accountTimezones);
    }
    return result;
};
//# sourceMappingURL=interactionTimezoneProcessor.js.map